import { lazy } from 'react'

export const AssetRoutes = [
    {
        path: '/assets',
        component: lazy(() => import('../views/asset-list')),
        exact: true,
        meta: {
            action: 'call',
            resource: "SST_VIEW_ASSET"
        }
    },
    {
        path: '/assets/archive',
        component: lazy(() => import('../views/asset-archive-list')),
        exact: true,
        meta: {
            action: 'call',
            resource: "SST_VIEW_ARCHIVED_ASSETS"
        }
    },
    {
        path: '/assets/types',
        component: lazy(() => import('../views/type-list')),
        exact: true,
        meta: {
            action: 'call',
            resource: "SST_VIEW_ASSET_TYPE"
        }
    },
    {
        path: '/assets/types/archive',
        component: lazy(() => import('../views/type-archive-list')),
        exact: true,
        meta: {
            action: 'call',
            resource: "SST_VIEW_ARCHIVED_ASSET_TYPES"
        }
    },
    {
        path: '/assets/:uuid',
        component: lazy(() => import('../views/asset-details')),
        exact: true,
        meta: {
            action: 'call',
            resource: "SST_VIEW_ASSET"
        }
    },
    {
        path: '/assets/types/:uuid',
        component: lazy(() => import('../views/type-detail')),
        exact: true,
        meta: {
            action: 'call',
            resource: "SST_VIEW_ASSET_TYPE"
        }
    }
]

